exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body,html{color:#666;font-size:14px;font-weight:400;font-family:Microsoft Yahei,simSun,Arial}h1{font-size:24px}h2{font:20px bold}h3{font-size:16px}a{color:#4183c4}p{line-height:24px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/common/scss/common/main.scss
// module id = 597
// module chunks = 2